/* =========================================================
   CATÁLOGO CON BUSCADOR Y FILTROS
   Lee MARCA y CATEGORIAS de catalogo.js (cargar este archivo después).
   Pinta las tarjetas en #lista-categorias y rellena el select
   #f-categoria del formulario de pedido (si existe).
   Incluye el carrito ("Tu pedido"): se guarda en el navegador y
   se envía como un solo mensaje de WhatsApp.
   ========================================================= */
(function () {
  "use strict";

  // Orden de los grupos del catálogo (y del filtro de calidad)
  const CALIDADES = ["Primera", "Primera y Segunda", "Segunda", "Primera Premium"];
  const idGrupo = (g) => "grupo-" + normalizar(g).replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  const rangoCalidad = (c) => { const i = CALIDADES.indexOf(c.calidad); return i < 0 ? CALIDADES.length : i; };

  // ---------- Utilidades ----------
  const normalizar = (s) =>
    String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  // "$ 70.000" (estilo de la referencia); "$ 2.800 / kg" si es por kilo
  const formatoPrecio = (n) => "$ " + Math.round(Number(n) || 0).toLocaleString("es-CL");
  const precioTexto = (c) => formatoPrecio(c.precio) + (c.porKilo ? " / kg" : "");

  const enlaceWA = (texto) =>
    `https://wa.me/${(typeof MARCA !== "undefined" && MARCA.whatsapp) || ""}?text=${encodeURIComponent(texto)}`;

  const mensajeWA = (c) => {
    const detalle = [c.calidad, precioTexto(c)].filter(Boolean).join(", ");
    const que = c.porKilo ? `${c.nombre} por kilo` : `el fardo ${c.nombre}`;
    return c.disponible
      ? `Hola! Quiero ${que} (${detalle}).`
      : `Hola! Quiero reservar ${que} (${detalle}). ¿Cuándo estará disponible?`;
  };

  const etiquetaOpcion = (c) =>
    [c.nombre, c.calidad, c.porKilo ? "por kilo" : ""].filter(Boolean).join(" · ");

  // ---------- Lógica de filtrado (pura, testeable) ----------
  const ESTADO_INICIAL = { q: "", tipo: "todos", calidad: "todas", disp: "todos", orden: "relevancia" };

  function filtrarCatalogo(lista, estado) {
    const e = Object.assign({}, ESTADO_INICIAL, estado);
    const terminos = normalizar(e.q).split(/\s+/).filter(Boolean);

    let res = lista.map((c, i) => ({ c, i })).filter(({ c }) => {
      if (e.tipo === "fardos" && c.porKilo) return false;
      if (e.tipo === "kilo" && !c.porKilo) return false;
      if (e.tipo === "promo" && !(c.promos && c.promos.length)) return false;
      if (e.calidad !== "todas" && c.calidad !== e.calidad) return false;
      if (e.disp === "disponibles" && !c.disponible) return false;
      if (e.disp === "reservar" && c.disponible) return false;
      if (terminos.length) {
        const texto = normalizar([c.nombre, c.calidad, c.descripcion, c.etiqueta, c.porKilo ? "por kilo kg" : "fardo",
          c.promos && c.promos.length ? "descuento oferta promo volumen" : ""].join(" "));
        const palabras = texto.split(/[^a-z0-9]+/);
        if (!terminos.every((t) => palabras.some((w) => w.startsWith(t)))) return false;
      }
      return true;
    });

    const cmp = {
      relevancia: (a, b) => rangoCalidad(a.c) - rangoCalidad(b.c) || a.i - b.i,
      "precio-asc": (a, b) => a.c.precio - b.c.precio || a.i - b.i,
      "precio-desc": (a, b) => b.c.precio - a.c.precio || a.i - b.i,
      nombre: (a, b) => a.c.nombre.localeCompare(b.c.nombre, "es", { sensitivity: "base" }) || a.i - b.i,
    }[e.orden] || ((a, b) => a.i - b.i);

    return res.sort(cmp).map(({ c }) => c);
  }

  const url = (p) => (window.XOXO_ASSET && window.XOXO_ASSET[p]) || p;

  // ---------- Tarjeta ----------
  function tarjetaHTML(c) {
    const imagen = c.video
      ? `<video src="${esc(url(c.video))}"${c.foto ? ` poster="${esc(url(c.foto))}"` : ""} autoplay muted loop playsinline preload="metadata" aria-label="Video del fardo ${esc(c.nombre)}"></video><span class="fardo-video-chip" aria-hidden="true">▶ Video real</span>`
      : c.foto
      ? `<img src="${esc(url(c.foto))}" alt="${esc(c.nombre)}" loading="lazy">`
      : `<span class="fardo-emoji" aria-hidden="true">${esc(c.emoji || "🧸")}</span>`;
    // Peso y unidades solo si están especificados
    const datos = c.porKilo
      ? `<div class="fardo-dato fardo-dato-kilo"><span>Venta por kilo</span></div>`
      : [c.peso && `<div class="fardo-dato"><dt>Peso</dt><dd>${esc(c.peso)}</dd></div>`,
         c.unidades && `<div class="fardo-dato"><dt>Unidades aprox.</dt><dd>${esc(c.unidades)}</dd></div>`]
          .filter(Boolean).join("");
    return `
      <article class="fardo-tarjeta${c.disponible ? "" : " fardo-agotado"}" id="fardo-${esc(c.id)}">
        <div class="fardo-imagen" style="background:${esc(c.color || "var(--cat-1)")}">
          ${imagen}
          ${c.etiqueta ? `<span class="fardo-insignia">${esc(c.etiqueta)}</span>` : ""}
          ${c.disponible ? "" : `<span class="fardo-insignia fardo-insignia-reserva">Por reservar</span>`}
        </div>
        <div class="fardo-cuerpo">
          ${c.calidad ? `<span class="fardo-chip">${esc(c.calidad)}</span>` : ""}
          <h3 class="fardo-nombre">${esc(c.nombre)}</h3>
          ${c.descripcion ? `<p class="fardo-desc">${esc(c.descripcion)}</p>` : ""}
          <p class="fardo-precio">${esc(precioTexto(c))}</p>
          ${c.promos && c.promos.length ? `<p class="fardo-promos"><span>Por volumen</span> ${c.promos.map((p) => `<strong>${p.cantidad} × ${esc(formatoPrecio(p.precio))}</strong>`).join(" ")}</p>` : ""}
          ${datos ? `<dl class="fardo-datos">${datos}</dl>` : ""}
          <div class="fardo-acciones">
            <button type="button" class="btn fardo-boton${c.disponible ? "" : " fardo-boton-reserva"}"
                    data-pedido-agregar="${esc(c.id)}">${c.disponible ? "🛒 Agregar al pedido" : "🛒 Agregar para reservar"}</button>
            <a class="fardo-wa" target="_blank" rel="noopener" href="${esc(enlaceWA(mensajeWA(c)))}">Preguntar solo por este fardo</a>
          </div>
        </div>
      </article>`;
  }

  // ---------- Pedido (carrito que se envía por WhatsApp) ----------
  const CLAVE_PEDIDO = "xoxo-pedido";
  const leerPedido = () => {
    try { return JSON.parse(localStorage.getItem(CLAVE_PEDIDO)) || {}; } catch (e) { return {}; }
  };
  const guardarPedido = (p) => {
    try { localStorage.setItem(CLAVE_PEDIDO, JSON.stringify(p)); } catch (e) { /* sin almacenamiento: vive en memoria */ }
  };

  // [{ c, cantidad }] en el orden del catálogo; ignora fardos que ya no existen
  const lineasPedido = (pedido, lista) =>
    lista.filter((c) => pedido[c.id] > 0).map((c) => ({ c, cantidad: pedido[c.id] }));

  const totalPedido = (lineas) => lineas.reduce((s, l) => s + l.c.precio * l.cantidad, 0);

  function mensajePedido(lineas) {
    return [
      "Hola! Quiero hacer este pedido:",
      ...lineas.map(({ c, cantidad }) =>
        `• ${cantidad}${c.porKilo ? " kg" : ""} × ${c.nombre}${c.calidad ? ` (${c.calidad})` : ""}` +
        ` — ${formatoPrecio(c.precio * cantidad)}${c.disponible ? "" : " · por reservar"}`),
      `Total: ${formatoPrecio(totalPedido(lineas))} + envío`,
      "¿Me confirman stock y el total con envío?",
    ].join("\n");
  }

  function iniciarPedido() {
    let pedido = leerPedido();
    let ultimoFoco = null;

    const panel = document.createElement("aside");
    panel.className = "pedido-panel";
    panel.id = "pedido-panel";
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
    panel.setAttribute("aria-labelledby", "pedido-titulo");
    panel.hidden = true;
    panel.innerHTML = `
      <div class="pedido-cabecera">
        <h2 id="pedido-titulo">Tu pedido</h2>
        <button type="button" class="pedido-x" data-pedido-cerrar aria-label="Cerrar pedido">×</button>
      </div>
      <div class="pedido-lista"></div>
      <div class="pedido-pie">
        <p class="pedido-total"><span>Total</span> <strong></strong></p>
        <p class="pedido-nota">El envío no está incluido. Te confirmamos stock, total y pago por WhatsApp.</p>
        <a class="btn btn-whatsapp pedido-enviar" target="_blank" rel="noopener">💬 Enviar pedido por WhatsApp</a>
        <button type="button" class="pedido-vaciar">Vaciar pedido</button>
      </div>`;
    const fondo = document.createElement("div");
    fondo.className = "pedido-fondo";
    fondo.hidden = true;
    fondo.setAttribute("data-pedido-cerrar", "");
    document.body.append(fondo, panel);

    const $lista = panel.querySelector(".pedido-lista");
    const $pie = panel.querySelector(".pedido-pie");
    const $total = panel.querySelector(".pedido-total strong");
    const $enviar = panel.querySelector(".pedido-enviar");

    function pintar() {
      const lineas = lineasPedido(pedido, CATEGORIAS);
      const n = lineas.reduce((s, l) => s + l.cantidad, 0);
      document.querySelectorAll(".pedido-cantidad").forEach((el) => { el.textContent = n; el.hidden = !n; });
      $pie.hidden = !lineas.length;
      $lista.innerHTML = lineas.length
        ? lineas.map(({ c, cantidad }) => `
          <div class="pedido-item">
            <div class="pedido-info">
              <strong>${esc(c.nombre)}</strong>
              <span>${esc([c.calidad, precioTexto(c) + (c.porKilo ? "" : " c/u"), c.disponible ? "" : "por reservar"].filter(Boolean).join(" · "))}</span>
            </div>
            <div class="pedido-cant" role="group" aria-label="Cantidad de ${esc(c.nombre)}">
              <button type="button" data-pedido-menos="${esc(c.id)}" aria-label="Quitar uno">−</button>
              <span>${cantidad}${c.porKilo ? " kg" : ""}</span>
              <button type="button" data-pedido-mas="${esc(c.id)}" aria-label="Agregar uno">+</button>
            </div>
            <strong class="pedido-subtotal">${esc(formatoPrecio(c.precio * cantidad))}</strong>
            <button type="button" class="pedido-quitar" data-pedido-quitar="${esc(c.id)}" aria-label="Eliminar ${esc(c.nombre)} del pedido">✕</button>
          </div>`).join("")
        : `<p class="pedido-vacio">Tu pedido está vacío.<br>Agrega fardos desde el catálogo con <strong>🛒 Agregar al pedido</strong>.</p>`;
      $total.textContent = formatoPrecio(totalPedido(lineas));
      $enviar.href = enlaceWA(mensajePedido(lineas));
    }

    function cambiar(id, delta) {
      pedido[id] = Math.max(0, (pedido[id] || 0) + delta);
      if (!pedido[id]) delete pedido[id];
      guardarPedido(pedido);
      pintar();
    }

    function abrir() {
      ultimoFoco = document.activeElement;
      panel.hidden = fondo.hidden = false;
      document.body.classList.add("pedido-abierto");
      panel.querySelector(".pedido-x").focus();
    }
    function cerrar() {
      panel.hidden = fondo.hidden = true;
      document.body.classList.remove("pedido-abierto");
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }

    document.addEventListener("click", (e) => {
      const t = e.target.closest("[data-pedido-agregar],[data-pedido-mas],[data-pedido-menos],[data-pedido-quitar],[data-pedido-abrir],[data-pedido-cerrar],.pedido-vaciar");
      if (!t) return;
      const d = t.dataset;
      if (d.pedidoAgregar) {
        cambiar(d.pedidoAgregar, 1);
        if (!t.dataset.texto) t.dataset.texto = t.textContent;
        t.textContent = "✓ Agregado al pedido";
        t.classList.add("fardo-boton-ok");
        clearTimeout(t._xoxo);
        t._xoxo = setTimeout(() => { t.textContent = t.dataset.texto; t.classList.remove("fardo-boton-ok"); }, 1600);
        document.querySelectorAll(".pedido-boton").forEach((b) => {
          b.classList.remove("pedido-latido"); void b.offsetWidth; b.classList.add("pedido-latido");
        });
      } else if (d.pedidoMas) cambiar(d.pedidoMas, 1);
      else if (d.pedidoMenos) cambiar(d.pedidoMenos, -1);
      else if (d.pedidoQuitar) cambiar(d.pedidoQuitar, -Infinity);
      else if ("pedidoAbrir" in d) abrir();
      else if ("pedidoCerrar" in d) cerrar();
      else if (t.classList.contains("pedido-vaciar")) { pedido = {}; guardarPedido(pedido); pintar(); }
    });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !panel.hidden) cerrar(); });

    pintar();
  }

  // ---------- Buscador rápido (panel que abre la lupa de la cabecera) ----------
  const POPULARES = ["Famoso", "TY", "Esponjoso", "Stitch", "Navidad", "Halloween", "Muñeca", "Peluches Brillos"];

  function iniciarBuscadorRapido({ limpiar, estado, pintar, buscador }) {
    const lupas = document.querySelectorAll("[data-buscar]");
    if (!lupas.length) return;
    const coincide = (q) => filtrarCatalogo(CATEGORIAS, { q });
    const grupos = [...new Set(CATEGORIAS.map((c) => c.calidad || "Otros"))]
      .sort((a, b) => rangoCalidad({ calidad: a }) - rangoCalidad({ calidad: b }));
    const populares = POPULARES.filter((t) => coincide(t).length);

    const panel = document.createElement("div");
    panel.className = "buscador-panel";
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
    panel.setAttribute("aria-label", "Buscar fardos");
    panel.hidden = true;
    panel.innerHTML = `
      <div class="buscador-caja">
        <div class="buscador-fila">
          <label class="buscador-campo">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
            <span class="filtro-oculto">Buscar fardos</span>
            <input type="search" placeholder="Buscar fardos…" autocomplete="off" enterkeyhint="search">
          </label>
          <button type="button" class="buscador-cancelar" data-buscador-cerrar>Cancelar</button>
        </div>
        <div class="buscador-sugerencias">
          <p class="buscador-titulo">Búsqueda rápida por calidad</p>
          <div class="buscador-chips">${grupos.map((g) =>
            `<button type="button" class="buscador-chip" data-ir-grupo="${esc(g)}">${esc(g === "Otros" ? "Otros" : "Fardos " + g)}</button>`).join("")}</div>
          ${populares.length ? `<p class="buscador-titulo">Búsquedas populares</p>
          <div class="buscador-chips">${populares.map((t) =>
            `<button type="button" class="buscador-chip" data-buscar-termino="${esc(t)}">${esc(t)}</button>`).join("")}</div>` : ""}
        </div>
        <div class="buscador-resultados" hidden></div>
      </div>`;
    const fondo = document.createElement("div");
    fondo.className = "buscador-fondo";
    fondo.hidden = true;
    fondo.setAttribute("data-buscador-cerrar", "");
    document.body.append(fondo, panel);

    const input = panel.querySelector("input");
    const $sug = panel.querySelector(".buscador-sugerencias");
    const $res = panel.querySelector(".buscador-resultados");
    let ultimoFoco = null;

    function abrir() {
      ultimoFoco = document.activeElement;
      panel.hidden = fondo.hidden = false;
      document.body.classList.add("buscador-abierto");
      input.value = "";
      resultados();
      setTimeout(() => input.focus(), 30);
    }
    function cerrar(devolverFoco = true) {
      panel.hidden = fondo.hidden = true;
      document.body.classList.remove("buscador-abierto");
      if (devolverFoco && ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
    }

    function resultados() {
      const q = input.value.trim();
      $sug.hidden = !!q;
      $res.hidden = !q;
      if (!q) return;
      const res = coincide(q);
      $res.innerHTML = res.length
        ? `<p class="buscador-titulo">${res.length} ${res.length === 1 ? "fardo encontrado" : "fardos encontrados"}</p>
           <ul class="buscador-lista">${res.slice(0, 8).map((c) => `
             <li><button type="button" class="buscador-item" data-ir-fardo="${esc(c.id)}">
               <span class="buscador-item-emoji" aria-hidden="true">${esc(c.emoji || "🧸")}</span>
               <span class="buscador-item-texto"><strong>${esc(c.nombre)}</strong><small>${esc(c.calidad || "")}</small></span>
               <span class="buscador-item-precio">${esc(precioTexto(c))}</span>
             </button></li>`).join("")}</ul>
           ${res.length > 8 ? `<button type="button" class="btn btn-primario buscador-todos" data-ver-todos>Ver los ${res.length} fardos</button>` : ""}`
        : `<p class="buscador-vacio">No encontramos «${esc(q)}». Prueba con otra palabra o escríbenos por WhatsApp.</p>`;
    }

    // Lleva el catálogo a un estado limpio (o con la búsqueda puesta) y salta a un elemento
    function irA(id, q) {
      cerrar(false);
      if (q) { limpiar(); estado.q = q; if (buscador) buscador.value = q; pintar(); } else limpiar();
      const ir = () => { const d = document.getElementById(id); if (d) d.scrollIntoView({ block: "start", behavior: "instant" }); };
      ir();
      setTimeout(ir, 300);
      const d = document.getElementById(id);
      if (d && d.classList.contains("fardo-tarjeta")) {
        d.classList.remove("fardo-resaltado"); void d.offsetWidth; d.classList.add("fardo-resaltado");
      }
    }

    input.addEventListener("input", resultados);
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && input.value.trim()) { e.preventDefault(); irA("catalogo-contador", input.value.trim()); }
    });
    lupas.forEach((b) => b.addEventListener("click", abrir));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !panel.hidden) cerrar(); });
    document.addEventListener("click", (e) => {
      const t = e.target.closest("[data-buscador-cerrar],[data-ir-fardo],[data-buscar-termino],[data-ver-todos],.buscador-chip[data-ir-grupo]");
      if (!t || !(panel.contains(t) || t === fondo)) return;
      const d = t.dataset;
      if ("buscadorCerrar" in d) cerrar();
      else if (d.irFardo) irA("fardo-" + d.irFardo);
      else if (d.irGrupo) irA(idGrupo(d.irGrupo));
      else if (d.buscarTermino) { input.value = d.buscarTermino; resultados(); input.focus(); }
      else if ("verTodos" in d) irA("catalogo-contador", input.value.trim());
    });
  }

  // ---------- Montaje en la página ----------
  function iniciar() {
    if (typeof CATEGORIAS === "undefined") return;
    const lista = document.getElementById("lista-categorias");

    // Formulario de pedido: opciones distinguibles (hay nombres repetidos con distinta calidad)
    const select = document.getElementById("f-categoria");
    if (select) {
      select.innerHTML = CATEGORIAS.map((c) => `<option>${esc(etiquetaOpcion(c))}</option>`).join("") +
        "<option>Aún no lo sé / asesoría</option>";
    }
    if (!lista) return;
    iniciarPedido();

    const $ = (id) => document.getElementById(id);
    const buscador = $("filtro-busqueda");
    const selCalidad = $("filtro-calidad");
    const selDisp = $("filtro-disponibilidad");
    const selOrden = $("filtro-orden");
    const tabs = Array.from(document.querySelectorAll("[data-filtro-tipo]"));
    const contador = $("catalogo-contador");
    const vacio = $("catalogo-vacio");
    const estado = Object.assign({}, ESTADO_INICIAL);

    if (selCalidad && selCalidad.options.length <= 1) {
      selCalidad.innerHTML = `<option value="todas">Todas</option>` +
        CALIDADES.map((q) => `<option value="${esc(q)}">${esc(q)}</option>`).join("");
    }

    function pintar() {
      const res = filtrarCatalogo(CATEGORIAS, estado);
      // En "Relevancia" los fardos van agrupados por calidad, con un título por grupo
      if (estado.orden === "relevancia") {
        const cuenta = {};
        res.forEach((c) => { cuenta[c.calidad || "Otros"] = (cuenta[c.calidad || "Otros"] || 0) + 1; });
        let grupo = null;
        lista.innerHTML = res.map((c) => {
          const g = c.calidad || "Otros";
          const titulo = g === grupo ? "" :
            `<h3 class="catalogo-grupo" id="${idGrupo(g)}"><span>${esc(g)}</span> <small>${cuenta[g]} ${cuenta[g] === 1 ? "fardo" : "fardos"}</small></h3>`;
          grupo = g;
          return titulo + tarjetaHTML(c);
        }).join("");
      } else {
        lista.innerHTML = res.map(tarjetaHTML).join("");
      }
      if (contador) contador.textContent = `${res.length} ${res.length === 1 ? "categoría encontrada" : "categorías encontradas"}`;
      if (vacio) vacio.hidden = res.length > 0;
      tabs.forEach((t) => {
        const activo = t.dataset.filtroTipo === estado.tipo;
        t.classList.toggle("activo", activo);
        t.setAttribute("aria-pressed", activo);
      });
    }

    function limpiar() {
      Object.assign(estado, ESTADO_INICIAL);
      if (buscador) buscador.value = "";
      if (selCalidad) selCalidad.value = "todas";
      if (selDisp) selDisp.value = "todos";
      if (selOrden) selOrden.value = "relevancia";
      pintar();
    }

    buscador && buscador.addEventListener("input", () => { estado.q = buscador.value; pintar(); });
    selCalidad && selCalidad.addEventListener("change", () => { estado.calidad = selCalidad.value; pintar(); });
    selDisp && selDisp.addEventListener("change", () => { estado.disp = selDisp.value; pintar(); });
    selOrden && selOrden.addEventListener("change", () => { estado.orden = selOrden.value; pintar(); });
    tabs.forEach((t) => t.addEventListener("click", () => { estado.tipo = t.dataset.filtroTipo; pintar(); }));
    document.querySelectorAll("[data-filtro-limpiar]").forEach((b) => b.addEventListener("click", limpiar));

    // Búsqueda rápida: un botón por calidad que salta a su grupo de fardos
    const rapida = $("busqueda-rapida");
    if (rapida) {
      const grupos = [...new Set(CATEGORIAS.map((c) => c.calidad || "Otros"))]
        .sort((a, b) => rangoCalidad({ calidad: a }) - rangoCalidad({ calidad: b }));
      rapida.innerHTML = grupos.map((g) =>
        `<button type="button" class="rapida-chip" data-ir-grupo="${esc(g)}">${esc(g === "Otros" ? "Otros" : "Fardos " + g)}</button>`).join("");
      rapida.addEventListener("click", (e) => {
        const b = e.target.closest("[data-ir-grupo]");
        if (!b) return;
        // Si hay filtros puestos, se quitan para que el grupo se vea completo
        if (estado.orden !== "relevancia" || estado.q || estado.calidad !== "todas" || estado.disp !== "todos") limpiar();
        // Salto directo (una animación larga se corta cuando cargan fotos) y ajuste por si algo se movió
        const ir = () => { const d = document.getElementById(idGrupo(b.dataset.irGrupo)); if (d) d.scrollIntoView({ block: "start", behavior: "instant" }); };
        ir();
        setTimeout(ir, 300);
      });
    }

    iniciarBuscadorRapido({ limpiar, estado, pintar, buscador });

    pintar();
  }

  // Exponer para pruebas / consola
  if (typeof window !== "undefined") {
    window.CatalogoFiltros = { filtrarCatalogo, normalizar, formatoPrecio, precioTexto, mensajeWA, mensajePedido, CALIDADES };
  }
  if (typeof module !== "undefined" && module.exports) {
    module.exports = { filtrarCatalogo, normalizar, formatoPrecio, precioTexto, mensajeWA, mensajePedido, lineasPedido, tarjetaHTML, CALIDADES };
  }

  if (typeof document !== "undefined") {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
    else iniciar();
  }
})();
